import {defineMessages} from 'react-intl';

export default defineMessages({
  chapters: {
    defaultMessage: '{chapters, plural, one {# Chapter} other {# Chapters}}',
    id: 'CourseDetailPage.Header.CourseLabels.Chapters',
  },
});
